"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 7H6v12h12zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5M16 17H8v-2h8zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M8 15h8v2H8z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3m-2 10H6V7h12z"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "11.5",
  r: "1.5"
}, "3"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "11.5",
  r: "1.5"
}, "4")], 'SmartToyTwoTone');